import React from 'react';
import socketio from "socket.io-client";
//import { SOCKET_URL } from "config";

//https://chat.gamingsfinest.com

export const socket = socketio.connect('https://chat.gamingsfinest.com');
export const SocketContext = React.createContext();
